// Import dependencies
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { userUpdate } from '../../../actions/users';
import { capaGetByUserAndTeam, capaCreate } from '../../../actions/capa';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { browserName } from 'react-device-detect';
import { driver } from "driver.js";


// Import CSS & assets
import './Dashboard.css';
import 'driver.js/dist/driver.css';
import ico_dashboard_outline from '../../../assets/ico/ico_dashboard_outline.svg';
import ico_dashboard_fill from '../../../assets/ico/ico_dashboard_fill.svg';
import ico_user_outline from '../../../assets/ico/ico_user_outline.svg';
import ico_user_fill from '../../../assets/ico/ico_user_fill.svg';
import ico_home_outline from '../../../assets/ico/ico_home_outline.svg';
import ico_home_fill from '../../../assets/ico/ico_home_fill.svg';
import ico_combi_outline from '../../../assets/ico/ico_combi_outline.svg';
import ico_combi_fill from '../../../assets/ico/ico_combi_fill.svg';
import ico_arrow from '../../../assets/ico/ico_arrow_up.svg';
import building from '../../../assets/building_small.png';
import logo_card from '../../../assets/logo_card.svg';


// Import components
import Header from '../../../components/app/header/Header';
import Navbar from '../../../components/app/navbar/Navbar';
import Card from '../../../components/app/card/Card';
import Group from '../../../components/app/group/Group';
import Filter from '../../../components/app/filter/Filter';
import Input from '../../../components/common/input/Input';
import NewCapa from '../../../components/app/newCapa/NewCapa';
import ModalIosApp from '../../../components/common/modaliosapp/ModalIosApp';
import ErrorPage from '../../../components/common/errorPage/ErrorPage';
import DoughnutChart from '../../../components/charts/DoughnutChart';
import HorizontalBarChart from '../../../components/charts/HorizontalBarChart';
import MiniMap from '../../../components/common/miniMap/MiniMap';
import NotAllowed from '../../auth/notallowed/NotAllowed';
import Popup from '../../../components/common/popup/Popup';
import ToasterContainer from '../../../components/common/toaster/ToasterContainer';



// Import external functions
import * as helpers from '../../../helpers/Other_helpers';
import * as popup_helpers from '../../../helpers/popup/PopUp_helpers';

// Toaster
var toasterData_all = {
    // land: { title: "Données terrain", text: "Analyse des données du terrain : limites, topographie et constructions exitantes.", type: "progress", style: "default", status: "closed" },
    // risks: { title: "Risques", text: "Analyse des risques rattachés au terrain : risques naturels et industriels, sismicité, sols argileux, canalisations et pollution du sol.", type: "progress", style: "default", status: "closed" },
    // context: { title: "Données contextuelles", text: "Analyse des données contextuelles du terrain : statistiques de population, marché immobilier et présence de monuments historiques.", type: "progress", style: "default", status: "closed" },
    // gpu: { title: "Données PLU", text: "Récupération des données d'urbanisme issues du Géoportail de l'Urbanisme.", type: "progress", style: "default", status: "closed" },
    // buildable: { title: "Capacité constructible", text: "Calcul de la capacité constructible du terrain.", type: "progress", style: "default", status: "closed" },
    // combinations: { title: "Simulations de construction", text: "Génération des simulations de construction sur le terrain.", type: "progress", style: "default", status: "closed" },
    // save: { title: "Enregistrement", text: "Enregistrement des dernières modifications apportées à l'étude.", type: "progress", style: "default", status: "closed" },
    message: { title: "", text: "", type: "", style: "", status: "closed" },
}


const Dashboard = ({ version, environment }) => {

    // DRIVER.JS
    const startVisit = (startFrom) => {
        setTargetSection(0);
        setForceToggle("close");
        console.log("START ONBOARDING");

        // Create steps
        var steps = [
            { popover: { title: 'Dashboard', description: "Cette page est votre accueil principal.\nVous allez être guidé pour découvrir tous les éléments important qui s'y trouvent." } },
            { element: '#dashboard_title_0', popover: { title: 'Section"Profil"', description: 'Cette section regroupe toutes vos données principales.', side: "bottom", align: 'center' } },
            { element: '#dashboard_personal', popover: { title: 'Informations personnelles', description: "Retrouvez ici vos informations et statistiques personnelles.", side: "right", align: 'start' } },
            { element: '#dashboard_team', popover: { title: "Informations d'équipe", description: "Retrouvez ici les informations et statistiques de votre équipe.", side: "left", align: 'start' } },
        ];
        // if (window.innerWidth > 550) {
        if (document.getElementById("header").offsetWidth > 1340) {
            steps.push(
                { element: '#dashboard_last_studies', popover: { title: "Dernières études capacitaires", description: "Retrouvez ici les études les plus récentes de toute votre équipe.", side: "left", align: 'start' } },
            );
        }
        steps.push(
            { element: '#navbar-container', popover: { title: 'Navigation', description: 'Naviguez facilement entre les sections.\nAllons voir la section suivante.', side: "right", align: 'start' } },
            { element: '#dashboard_title_1', popover: { title: 'Section "Études Capacitaires"', description: 'Cette section regroupe toutes vos études capacitaires.', side: "bottom", align: 'center' } },
            { element: '#dashboard_new_capa', popover: { title: 'Nouvelle étude', description: 'Créez rapidement une nouvelle étude capacitaire.', side: "right", align: 'start' } },
            { popover: { title: 'Fin de la visite', description: 'Voilà, vous êtes prêt à naviguer dans votre Dashboard.' } },
        );
        if (startFrom === "popup_new_user") {
            steps.push(
                { element: '#dashboard_user_info', popover: { title: 'Rejouer cette visite', description: 'Rejouez cette visite guidée quand vous voulez en cliquant sur "Visite guidée".', side: "left", align: 'start' } },
            );
        }

        const driverObj = driver({
            showProgress: true,
            popoverClass: 'driver_popover',
            nextBtnText: 'Suivant',
            prevBtnText: 'Précédent',
            doneBtnText: 'Terminer',
            steps: steps,
            onNextClick: () => {
                var current_step_index = driverObj.getActiveIndex();
                var current_step = driverObj.getActiveStep();
                console.log('Next from', current_step_index, current_step);
                // Custom actions
                if (current_step?.popover?.title === "Navigation") {
                    setTargetSection(1);
                    setTimeout(() => {
                        driverObj.moveNext();
                    }, 600);
                }
                else if (current_step?.popover?.title === "Fin de la visite" && driverObj.hasNextStep()) {
                    setForceToggle("open");
                    setTimeout(() => {
                        driverObj.moveNext();
                    }, 200);
                }
                else if (current_step?.popover?.title === "Rejouer cette visite") {
                    driverObj.moveNext();
                    setForceToggle("close");
                }
                else {
                    driverObj.moveNext();
                }
            },
            onPrevClick: () => {
                var current_step_index = driverObj.getActiveIndex();
                var current_step = driverObj.getActiveStep();
                console.log('Previous from', current_step_index, current_step);
                // Custom actions
                if (current_step?.popover?.title === "Navigation") {
                    setTargetSection(0);
                    setTimeout(() => {
                        driverObj.movePrevious();
                    }, 600);
                }
                else if (current_step?.popover?.title === "Rejouer cette visite") {
                    driverObj.movePrevious();
                    setForceToggle("close");
                }
                else {
                    driverObj.movePrevious();
                }
            },
            onDestroyStarted: () => {
                setForceToggle("close");
                driverObj.destroy();
            },
        });

        driverObj.drive();
    }


    // console.log("USER INFO", navigator);
    // Set body color
    // document.body.style.background = "#f5f5f5";

    // ERROR MANAGEMENT
    const [isError, setIsError] = useState(false);
    const createError = () => {
        console.log("CREATE ERROR");
        // setIsError(true);
        console.log("capacityFullList", capacityFullList);
        console.log("capacityFullList", capacityFullList[100].id);
    }



    // Set global funcitons
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();


    // Global variables
    const layout = [
        {
            title_long: "Profil",
            title_short: "Profil",
            ico_outline: ico_user_outline,
            ico_fill: ico_user_fill,
            isVisible: true,
            steps: [],
            sub: [],
        },
        // {
        //     title_long: "Mon équipe",
        //     title_short: "EQUIPE",
        //     ico_outline: ico_team_outline,
        //     ico_fill: ico_team_fill,
        //     isVisible: true
        // },
        {
            title_long: "Études Capacitaires",
            title_short: "Études",
            ico_outline: ico_combi_outline,
            ico_fill: ico_combi_fill,
            isVisible: true,
            steps: [],
            sub: [],
        },
    ]
    const isApp = false;

    // Set hooks
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const [targetSection, setTargetSection] = useState(null);
    const [currentSection, setCurrentSection] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(checkModal());
    const [forceToggle, setForceToggle] = useState(null);
    const [isCreatingNewCapa, setIsCreatingNewCapa] = useState(false);
    // Header & Footer height
    const [headerHeight, setHeaderHeight] = useState(80);
    const [footerHeight, setFooterHeight] = useState(0);


    // TEST CAPACITY
    const [capacityFullList, setCapacityFullList] = useState(["fetching"]);
    const [capacityFilteredList, setCapacityFilteredList] = useState([]);
    const [capacityFilteredLimit, setCapacityFilteredLimit] = useState(100);
    const [isLeft, setIsLeft] = useState(true);
    const [gridGap, setGridGap] = useState(30);
    const [capacitySearch, setCapacitySearch] = useState("");
    var nbCapaTop = 0;
    useEffect(() => {
        var list = [];
        for (var i = 0; i < 20; i++) {
            list.push(
                {
                    id: i,
                    title: "Etude numéro " + i,
                    description: "Description de l'étude " + i,
                    city: "Ville " + i,
                    PLUZone: "Zone " + i,
                }
            );
        }
        // setCapacityFullList(list);
        // setCapacityFilteredList(list);
    }, []);
    function getIsLeft() {
        var gap = 30;
        var card_width = 260;
        var card_container = document.getElementById('card_container');
        var card_container_width = card_container ? card_container.offsetWidth : 0;
        var inline_max = Math.floor((card_container_width + gap) / (card_width + gap));
        var inline_gap = (card_container_width - (inline_max * card_width)) / (inline_max - 1);
        if (capacityFilteredList.length < inline_max) {
            setIsLeft(true);
            setGridGap(inline_gap);
        }
        else {
            setIsLeft(false);
            setGridGap(30);
        }
    }
    useEffect(() => {
        // console.log("CHANGE FILTERED LIST", capacityFilteredList);
        getIsLeft();
    }, [capacityFilteredList]);
    // Resize window
    useEffect(() => {
        handleWindowResize();
        window.addEventListener('resize', handleWindowResize, { passive: true });
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    const handleWindowResize = () => {
        // console.log("RESIZE");
        // Check header's height
        setHeaderHeight(document.getElementById('header')?.offsetHeight || 80);
        // Check footer's height
        if (window.innerWidth < 550) {
            setFooterHeight(80);
        }
        else {
            setFooterHeight(0);
        }
        // Check dashboard height
        checkDashboardHeight();
    }
    const openCapa = (capaId) => {
        // navigate('/capacity/' + capaId);
        navigate('/capastudy/' + capaId);
    }

    // Set hook functions
    // On load : Set input values for user firstname and lastname
    // useEffect(() => {
    // document.getElementById('firstName').value = user?.result?.firstName;
    // document.getElementById('lastName').value = user?.result?.lastName;
    // }, []);
    // On load : Get capacities list from user id and team id
    useEffect(() => {
        console.log("-FETCHING TEAM CAPAS- : Loading...");
        // Get minimum nb of items to fetch
        var limit = 5;
        if (window.innerWidth > 1000) {
            limit = Math.floor((window.innerWidth - 150) / 290) * 2 - 1;
        }
        // console.log("limit", limit);
        setCapacityFilteredLimit(limit);
        var teamId = "";
        if (user?.teams && user.teams.length > 0) { teamId = user.teams[0]._id };
        const filter = {
            userId: user?.result?._id,
            teamId: teamId,
            limit: limit
        }
        dispatch(capaGetByUserAndTeam(filter, handleCapaGetSuccess, handleCapaGetFail));
    }, []);

    const switchCapacityFilteredLimit = () => {
        if (capacityFilteredLimit === null) {
            setCapacityFilteredLimit(Math.floor((window.innerWidth - 150) / 290) * 2 - 1);
        }
        else {
            setCapacityFilteredLimit(null);
        }
    }

    // Create new capa
    const createNewCapa = () => {
        setIsCreatingNewCapa(true);
        // Check new capa is allowed
        var new_capa_allowed = false;
        var isLastAllowed = false;
        if (!(user?.teams[0]?.plan?.limitations?.nb_capa_max)) {
            console.log("No limitations");
            new_capa_allowed = true;
        }
        else if (capacityFullList.length < user?.teams[0]?.plan?.limitations?.nb_capa_max) {
            console.log("Limitations not reached, ", user?.teams[0]?.plan?.limitations?.nb_capa_max - capacityFullList.length, " available");
            new_capa_allowed = true;
            if (user?.teams[0]?.plan?.limitations?.nb_capa_max - capacityFullList.length === 1) {
                isLastAllowed = true;
            }
        }
        else {
            console.log("Limitations reached");
            setToasterMessage("Quota atteint", "Obtenez un compte Premium pour continuer à créer des études capacitaires.\n\nContactez notre équipe à hello@proplab.fr.");
            setIsCreatingNewCapa(false);
        }

        // If allowed, create new capa
        if (new_capa_allowed) {
            var userId = "";
            var teams = [];
            var info = {
                user_name: "",
                team_name: "",
                group_type: null,
                isLastAllowed: isLastAllowed,
            };
            if (user?.result?._id) { userId = user.result._id; info.user_name = (user?.result?.firstName || "") + " " + (user?.result?.lastName || "") };
            if (user?.teams && user.teams.length > 0) { teams = [user.teams[0]._id]; info.team_name = user.teams[0]?.name || "" };
            const formData = { userId, teams, info };
            // setTimeout(() => {
            //     console.log("CREATION");
            //     setIsCreatingNewCapa(false);
            // }, 2000);
            dispatch(capaCreate(formData, handleSuccess, handleFail));
        }
    }
    // Loading
    const handleSuccess = (data) => {
        console.log("SUCCESS", data);
        navigate(`/capastudy/${data.result._id}`);
    }
    const handleFail = (error) => {
        console.log("FAIL", error.response.data.message);
        setToasterMessage("Erreur", "Une erreur est survenue.\n\nSi cela persiste, contactez notre équipe à hello@proplab.fr.");
        setIsCreatingNewCapa(false);
    }

    // Set specific funciton
    // Dashboard dimensions
    const checkDashboardHeight = () => {
        var newValue = getDashboardHeight();
        if (newValue !== dashboardHeight) {
            setDashboardHeight(newValue);
        }
    }
    const getDashboardHeight = () => {
        var header_height = document.getElementById('header')?.offsetHeight || 80;
        var bottom_margin = 30;
        var title_height = 70;
        return (window.innerHeight - header_height - title_height)
    }
    const [dashboardHeight, setDashboardHeight] = useState(getDashboardHeight());
    // Check device
    function checkModal() {
        if (browserName === "Mobile Safari" && window.navigator.standalone === false) {
            return true;
        }
        else {
            return false;
        }
    }
    // Change section
    const updateCurrentSection = (value) => {
        setCurrentSection(value);
    }
    // Get random avatar
    function getRandomAvatar(length, type) {
        if (type === "initials") {
            return 'https://avatars.dicebear.com/api/initials/' + user?.result?.firstName.charAt(0) + user?.result?.lastName.charAt(0) + '.svg?b=%23062134';
        }
        else {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return 'https://avatars.dicebear.com/api/adventurer-neutral/' + result + '.svg?scale=90';
        }
    }
    // Get custom avatar
    const handleFileRead = async (event) => {
        // Get file from input
        const file = event.target.files[0];
        console.log(file);
        // Convert to base64
        const base64 = await convertBase64(file);
        console.log(base64);
        // Set base64 as avatar
        handleUserChangeAvatar(base64);
        // Reset input
        document.getElementById("avatar_input").value = "";
    }
    function convertBase64(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }
    // Update user data
    const handleUserChangeAvatarInitials = async () => {

        var base64 = await getInitialsB64(user?.result?.firstName, user?.result?.lastName);

        const newData = {
            firstName: user?.result?.firstName,
            lastName: user?.result?.lastName,
            avatar: base64,
        }
        if (newData.avatar !== "" && newData.avatar !== user?.result?.avatar) {
            handleUserUpdate(newData);
        }
        else {
            console.log("profile pic is already initals");
        }
    }
    const getInitialsB64 = async (firstName, lastName) => {
        var initals = "";
        if (firstName && firstName.length > 0) {
            initals += firstName[0];
        }
        if (lastName && lastName.length > 0) {
            initals += lastName[0];
        }

        var svg_string = '<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="200" fill="#062134"/><text fill="white" xml:space="preserve" style="white-space: pre" font-family="Helvetica" font-size="100" letter-spacing="0.em" text-anchor="middle" x="100" y="135">' + initals + '</text></svg>';
        const base64 = await convertBase64(new Blob([svg_string], { type: 'image/svg+xml' }));

        return base64
    }
    const handleUserChangeAvatar = (avatar) => {
        const newData = {
            firstName: user?.result?.firstName,
            lastName: user?.result?.lastName,
            avatar: avatar,
        }
        if (newData.avatar !== "" && newData.avatar !== user?.result?.avatar) {
            handleUserUpdate(newData);
        }
        else {
            console.log("user.avatar invalid");
        }
    }
    const handleUserChangeFirstName = async (e) => {
        var value = e.target.value;

        if (value.length === 0) {
            console.log("cannot be empty");
            document.getElementById('firstName').value = user?.result?.firstName;
            return
        }
        else if (value.length === 1) {
            value = e.target.value.toUpperCase();
        }
        else {
            value = e.target.value[0].toUpperCase() + e.target.value.slice(1).toLowerCase();
        }

        const newData = {
            firstName: value,
            lastName: user?.result?.lastName,
            avatar: user?.result?.avatar,
        }
        if (newData.firstName !== "" && newData.firstName !== user?.result?.firstName) {
            if (user?.result?.avatar.includes("data:image/svg+xml;base64,")) {
                console.log("UPDATE PP");
                newData.avatar = await getInitialsB64(newData.firstName, user?.result?.lastName);
            }
            handleUserUpdate(newData);
            document.getElementById('firstName').value = value;
        }
        else {
            console.log("user.firstName invalid");
            document.getElementById('firstName').value = user?.result?.firstName;
        }
    }
    const handleUserChangeLastName = async (e) => {
        var value = e.target.value;

        if (value.length === 0) {
            console.log("cannot be empty");
            document.getElementById('lastName').value = user?.result?.firstName;
            return
        }
        else {
            value = e.target.value.toUpperCase();
        }

        const newData = {
            firstName: user?.result?.firstName,
            lastName: value,
            avatar: user?.result?.avatar,
        }
        if (newData.lastName !== "" && newData.lastName !== user?.result?.lastName) {
            if (user?.result?.avatar.includes("data:image/svg+xml;base64,")) {
                console.log("UPDATE PP");
                newData.avatar = await getInitialsB64(user?.result?.firstName, newData.lastName);
            }
            handleUserUpdate(newData);
            document.getElementById('lastName').value = value;
        }
        else {
            console.log("user.lastName invalid");
            document.getElementById('lastName').value = user?.result?.lastName;
        }
    }
    const handleUserViewedPopup = async (popupId) => {
        const newData = {
            firstName: user?.result?.firstName,
            lastName: user?.result?.lastName,
            avatar: user?.result?.avatar,
            popups: user?.result?.popups || []
        }
        if (!newData.popups.includes(popupId)) {
            newData.popups.push(popupId);
        }
        handleUserUpdate(newData);
    }
    const handleUserUpdate = (userData) => {
        console.log("updating user", userData);
        dispatch(userUpdate(user?.result?._id, { userData }, handleUpdateSuccess, handleUpdateFail));
    }
    const handleUpdateSuccess = (data) => {
        console.log("SUCCESS", data);
        setUser(JSON.parse(localStorage.getItem('profile')));
    }
    const handleUpdateFail = (error) => {
        console.log("FAIL", error.response.data.message);
    }
    const handleCapaGetSuccess = (data) => {
        console.log("-FETCHING TEAM CAPAS- : Success", data);
        setCapacityFullList(data);
        setCapacityFilteredList(data);
        getChartData(data);
        getPopup();
    }
    const handleCapaGetFail = (error) => {
        console.log("-FETCHING TEAM CAPAS- : Error", error.response.data.message);
    }

    // POPUP
    const [popupData, setPopupData] = useState(null);
    const getPopup = () => {
        // console.log("GET POPUP");
        var active_popups = popup_helpers.get_popup(user?.result?._id || null, (user?.teams && user.teams.length > 0 && user.teams[0]?._id) ? user.teams[0]._id : null);
        // console.log("ACTIVE POPUPS", active_popups);
        // Search for a single popup to show
        for (var i = 0; i < active_popups.length; i++) {
            if (active_popups[i]?.isPersistent === true || !(user?.result?.popups && user.result.popups.includes(active_popups[i]?.id))) {
                showPopup(active_popups[i]);
                break;
            }
        }
    }
    const showPopup = (popup_data) => {
        setTimeout(() => {
            // console.log("CREATE POPUP");
            setPopupData({ ...popup_data, isVisible: true });
        }, 1000)
    }
    const hidePopup = (popup_data) => {
        // console.log("CLOSE POPUP");
        setPopupData({ ...popup_data, isVisible: false });
        viewedPopup(popup_data);
        setTimeout(() => {
            setPopupData(null);
            if (popupData?.id === "new_user") {
                startVisit("popup_new_user");
            }
        }, 700)
    }
    const viewedPopup = (popup_data) => {
        // console.log("VIEWED POPUP");
        if (popup_data?.id) {
            handleUserViewedPopup(popup_data.id);
        }
    }

    // CHART
    const getChartData = (list) => {
        var nbStudyUser = list.filter(study => study.creationUserId === user?.result?._id);

        var studyByUser = list.filter(study => study.creationUserId === user?.result?._id);

        // Don't change chartData if no data
        if (studyByUser.length === 0) {
            return;
        }

        // Get last study
        var studyLastTime = Date.parse(studyByUser[studyByUser.length - 1].creationDate);
        // console.log("studyLast", studyLastTime);
        var today = new Date();
        // console.log("today", today);
        // console.log("Jour", today.getDay());
        var week_limit = today.getDay() * (1000 * 60 * 60 * 24);
        var month1_limit = today.getDate() * (1000 * 60 * 60 * 24);
        var month3_limit = month1_limit + (2 * 30 * (1000 * 60 * 60 * 24));
        var nbDaySinceToday = Math.ceil((today - studyLastTime) / (1000 * 60 * 60 * 24));
        // console.log("nbDaySinceToday", nbDaySinceToday);

        var studyUser = [0, 0, 0, 0];
        var studyAll = [0, 0, 0, 0];
        list.forEach(study => {
            if (study.creationUserId === user?.result?._id) {
                // Add to all
                studyUser[0]++;
                // Add to last 3 months
                if (Date.parse(study.creationDate) > (today - month3_limit)) {
                    studyUser[1]++;
                }
                // Add to last month
                if (Date.parse(study.creationDate) > (today - month1_limit)) {
                    studyUser[2]++;
                }
                // Add to last week
                if (Date.parse(study.creationDate) > (today - week_limit)) {
                    studyUser[3]++;
                }
            }
            // Add to all
            studyAll[0]++;
            // Add to last 3 months
            if (Date.parse(study.creationDate) > (today - month3_limit)) {
                studyAll[1]++;
            }
            // Add to last month
            if (Date.parse(study.creationDate) > (today - month1_limit)) {
                studyAll[2]++;
            }
            // Add to last week
            if (Date.parse(study.creationDate) > (today - week_limit)) {
                studyAll[3]++;
            }
        })
        // console.log("studyUser", studyUser);
        // console.log("studyAll", studyAll);

        setBarChartData({
            labels: ["Toutes les études", "Etudes réalisées les 3 derniers mois", "Etudes réalisées ce moi-ci", "Etudes réalisées cette semaine"],
            datasets: [
                {
                    label: "Etudes de l'équipe",
                    data: studyAll,
                    backgroundColor: ["#062132", "#062132", "#062132", "#062132"],
                    borderColor: "#F1F1F1",
                    hoverBorderColor: "#F1F1F1",
                    borderWidth: 1,
                    hoverBorderWidth: 1
                },
                {
                    label: 'Mes études',
                    data: studyUser,
                    backgroundColor: ["#1ecd97", "#1ecd97", "#1ecd97", "#1ecd97"],
                    // backgroundColor: ["#00b398", "#00b398", "#00b398", "#00b398"],
                    borderColor: "#F1F1F1",
                    hoverBorderColor: "#F1F1F1",
                    borderWidth: 1,
                    hoverBorderWidth: 1
                },
            ],
        })


        // setChartData({
        //     labels: ["Mes études", "Autre études"],
        //     datasets: [
        //         {
        //             label: '',
        //             data: [nbStudyUser.length, list.length - nbStudyUser.length],
        //             backgroundColor: [
        //                 '#062132',
        //                 '#00b398',
        //             ],
        //             borderColor: "#F1F1F1",
        //             hoverBorderColor: "#F1F1F1",
        //             borderWidth: 1,
        //             hoverBorderWidth: 1
        //         },
        //     ],
        // });
    }

    const [chartData, setChartData] = useState({
        labels: ["Mes études", "Autre études"],
        datasets: [
            {
                label: '',
                data: [0, 0],
                backgroundColor: [
                    '#062132',
                    '#00b398',
                ],
                borderColor: "#F1F1F1",
                hoverBorderColor: "#F1F1F1",
                borderWidth: 1,
                hoverBorderWidth: 1
            },
        ],
    });
    const chartOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'right',
                align: 'middle'
            },
            // legend: {
            //     display: true,
            //     position: 'bottom',
            //     align: 'middle'
            // },
        }
    }
    const barChartOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'bottom'
            },
        },
        scales: {
            xAxis: {
                display: false,
                // stacked: true,
            },
            yAxis: {
                display: true,
                // stacked: true,
                ticks: {
                    stepSize: 1
                }
            }
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
    }
    const [barChartData, setBarChartData] = useState({
        labels: ["Toutes les études", "Etudes réalisées les 3 derniers mois", "Etudes réalisées ce moi-ci", "Etudes réalisées cette semaine"],
        datasets: [
            {
                label: "Etudes de l'équipe",
                data: [0, 0, 0, 0],
                backgroundColor: ["#062132", "#062132", "#062132", "#062132"],
                borderColor: "#F1F1F1",
                hoverBorderColor: "#F1F1F1",
                borderWidth: 1,
                hoverBorderWidth: 1
            },
            {
                label: 'Mes études',
                data: [0, 0, 0, 0],
                backgroundColor: ["#1ecd97", "#1ecd97", "#1ecd97", "#1ecd97"],
                // backgroundColor: ["#00b398", "#00b398", "#00b398", "#00b398"],
                borderColor: "#F1F1F1",
                hoverBorderColor: "#F1F1F1",
                borderWidth: 1,
                hoverBorderWidth: 1
            },
        ],
    });


    function prepareEmail() {
        var subject = "Demande de rattachement à une équipe";
        var body = "Bonjour,\r\n\r\nJe souhaite que mon compte <" + user?.result?.email + "> soit rattaché à une équipe afin de pouvoir utiliser pleinement l'outil.\r\n\r\nMerci de me recontacter à ce sujet.";
        var uri = "mailto:jordan@proplab.fr?subject=";
        uri += encodeURIComponent(subject);
        uri += "&body=";
        uri += encodeURIComponent(body);
        window.open(uri);
    }

    // Group
    const [currentGroupData, setCurrentGroupData] = useState(null);
    useEffect(() => {
        // console.log("SEARCH PARAM", searchParams.get("group_id"));
        if (searchParams.get("group_id")) {
            var search_id = searchParams.get("group_id");
            var matched_i = null;
            for (var i = 0; i < capacityFullList.length; i++) {
                if (capacityFullList[i]?._id === search_id) {
                    matched_i = i;
                    break;
                }
            }
            if (matched_i >= 0) {
                setCurrentGroupData(capacityFullList[matched_i]);
            }
            else {
                setCurrentGroupData(null);
            }
        }
        else {
            setCurrentGroupData(null);
        }
    }, [searchParams, capacityFullList]);

    // TOASTER MANAGEMENT
    const [toastersData, setToastersData] = useState(toasterData_all);
    const handleToaster = (actionList) => {
        // console.log("HANDLE TOASTER", actionList);
        // var oldData = { ...toastersData };
        var oldData = JSON.parse(JSON.stringify(toasterData_all));
        actionList.forEach(action => {
            // Update toaster elements
            if (action?.title) { oldData[action.key].title = action.title }
            if (action?.text) { oldData[action.key].text = action.text }
            if (action?.style) { oldData[action.key].style = action.style }
            if (action?.status) { oldData[action.key].status = action.status }
            // Set timeouts
            if (action.status === "success") {
                setTimeout(() => {
                    handleToaster([{ key: action.key, status: "done" }]);
                }, 3000);
            }
            else if (action.status === "info" || action.status === "error") {
                setTimeout(() => {
                    handleToaster([{ key: action.key, status: "done" }]);
                }, 6000);
            }
            else if (action.status === "done") {
                setTimeout(() => {
                    handleToaster([{ key: action.key, status: "closed" }]);
                }, 3000);
            }
        })
        toasterData_all = oldData;
        setToastersData(oldData);
    }
    const setToasterMessage = (title, message) => {
        handleToaster([{ key: "message", status: "info", type: "static", style: "default", title: title, text: message }]);
    }


    if (user?.token && (!user?.teams || user?.teams.length <= 0)) {
        return (
            <NotAllowed version={version} environment={environment} />
        )
    }
    else {
        return (
            <div>
                <ToasterContainer toastersData={toastersData} />
                <Header title="Dashboard" isApp={isApp} userHook={user} forceToggle={forceToggle} setForceToggle={setForceToggle} startVisit={startVisit} />
                <Navbar layout={layout} isApp={isApp} targetSection={targetSection} setTargetSection={setTargetSection} currentSection={currentSection} updateCurrentSection={updateCurrentSection} version={version} environment={environment} currentStep={null} />
                {isModalVisible &&
                    <ModalIosApp handleClose={setIsModalVisible} />
                }
                {isError &&
                    <ErrorPage setIsError={setIsError} version={version} />
                }
                {popupData?.id &&
                    <Popup popupData={popupData} hidePopup={hidePopup} user={user} />
                }
                {currentGroupData &&
                    <Group groupData={currentGroupData} capaListAll={capacityFullList} user={user} />
                }
                <div id="section_separator" className="dashboard__sectionseparator" style={{ top: headerHeight - 30 }}></div>
                <div id="section_data" className="dashboard__sectiondata" style={{ top: headerHeight, height: window.innerHeight - headerHeight - footerHeight }}>
                    <div id='section_0' className="dashboard__sectiondata_container">
                        <div className="dashboard__sectiondata_title_container">
                            <h3 id="dashboard_title_0">{layout[0]['title_long']}</h3>
                            <div className="dashboard__sectiondata_title_bar"></div>
                        </div>
                        <div id="section_body_container_user_data" className="dashboard__sectiondata_body_container">
                            <div id="dashboard_main" className="app__section_body" style={{ height: dashboardHeight + "px" }}>
                                <div className="app__section_dashboard">
                                    <div className="app__section_body_col12">
                                        <div id="dashboard_personal" className="app__section_body_col1">
                                            <div className="app__section_body_col1_row1 app__widget">
                                                <div className="app__widget2_title">Informations personnelles</div>
                                                <div className="dashboard__user_container">
                                                    <div className="app__userdata_avatar_container">
                                                        <div className="app__userdata_avatar">
                                                            <img src={user?.result?.avatar} alt="user_pp" />
                                                        </div>
                                                        <div className="app__userdata_avatar_container_buttons">
                                                            {/* <button onClick={() => { handleUserChangeAvatar(getRandomAvatar(10, "initials")) }}>Utiliser mes initiales</button> */}
                                                            <button onClick={() => { handleUserChangeAvatarInitials() }}>Utiliser mes initiales</button>
                                                            <span>ou</span>
                                                            {/* <button onClick={() => { handleUserChangeAvatar(getRandomAvatar(10, "adventurer-neutral")) }}>Générer un avatar aléatoire</button>
                                                            <span>ou</span> */}
                                                            <label htmlFor="avatar_input">Choisir une image</label>
                                                            <input type="file" id="avatar_input" name="avatar" accept="image/png, image/jpeg" onChange={e => handleFileRead(e)} />
                                                        </div>
                                                    </div>
                                                    {/* <div className="app__userdata_avatar_container">
                                                    <img src={user?.result?.avatar} alt="user_pp" />
                                                    <div className="app__userdata_avatar_container_buttons">
                                                        <button onClick={() => { handleUserChangeAvatar(getRandomAvatar(10, "initials")) }}>Utiliser mes initiales</button>
                                                        <span>ou</span>
                                                        <button onClick={() => { handleUserChangeAvatar(getRandomAvatar(10, "adventurer-neutral")) }}>Générer un avatar aléatoire</button>
                                                        <span>ou</span>
                                                        <label htmlFor="avatar_input">Choisir une image</label>
                                                        <input type="file" id="avatar_input" name="avatar" accept="image/png, image/jpeg" onChange={e => handleFileRead(e)} />
                                                    </div>
                                                </div> */}
                                                    <div className="app__userdata_info_container">
                                                        <div className="app__userdata_info_subcontainer">
                                                            <Input type='text' name='firstName' label='Prénom' defaultValue={user?.result?.firstName} handleBlur={handleUserChangeFirstName} isDark={true} />
                                                            <Input type='text' name='lastName' label='Nom' defaultValue={user?.result?.lastName} handleBlur={handleUserChangeLastName} isDark={true} />
                                                        </div>
                                                        {window.innerWidth > 550 &&
                                                            <Input type='text' name='email' label='Adresse mail' value={user?.result?.email} readOnly={true} isDark={true} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="app__section_body_col1_row2 app__widget">
                                                {(!user?.teams || user?.teams.length <= 0) &&
                                                    <div className="app__section_hide"></div>
                                                }
                                                {capacityFullList.length === 1 && capacityFullList[0] === "fetching" ?
                                                    <>
                                                        <div className="app__widget2_title">Statistiques personnelles</div>
                                                        <div className="app__sectiondata_loading_container_box">
                                                            <div className="app__sectiondata_loading"></div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div>
                                                            <div className="app__widget2_title">Statistiques personnelles</div>
                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <div className="dashboard__value_container">
                                                                    <div className="dashboard__value_text">{capacityFullList.filter(study => study.creationUserId === user?.result?._id).length}</div>
                                                                    <div className="dashboard__value_unit">études<br></br>capacitaires</div>
                                                                </div>
                                                                <div className="dashboard__value_container">
                                                                    {capacityFullList.filter(study => study.creationUserId === user?.result?._id).length > 0 ?
                                                                        <div className="dashboard__value_text">{helpers.get_pretty_num(Math.round((capacityFullList.filter(study => study.creationUserId === user?.result?._id)).map(study => study?.simplified?.buildable_area || 0).reduce((prev, next) => prev + next)))}</div>
                                                                        :
                                                                        <div className="dashboard__value_text">0</div>
                                                                    }
                                                                    <div className="dashboard__value_unit">m² constructibles</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {window.innerHeight > 840 &&
                                                            <>
                                                                <div className="app__sectiondata_widget_spacer_10"></div>
                                                                <div className="dashboard__barchart_container">
                                                                    {/* <DoughnutChart chartData={chartData} chartOptions={chartOptions} /> */}
                                                                    <HorizontalBarChart chartData={barChartData} chartOptions={barChartOptions} />
                                                                </div>
                                                            </>
                                                        }
                                                    </>
                                                }

                                            </div>
                                        </div>
                                        <div id="dashboard_team" className="app__section_body_col2">
                                            {(!user?.teams || user?.teams.length <= 0) &&
                                                <div className="app__section_hide">
                                                    <div className="app__sectiondata_loading_text" style={{ width: "70%" }}>
                                                        Vous devez être Premium pour utiliser toutes les fonctionnalités de Proplab.
                                                    </div>
                                                    <div className="app__section_hide_buttons">
                                                        <div className="combi__launch_button" onClick={() => { prepareEmail() }}>Passer Premium</div>
                                                        <div className="combi__launch_button_white" onClick={() => { prepareEmail() }}>Essayer gratuitement</div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="app__section_body_col2_row1 app__widget dashboard__container_dark" style={{ position: "relative" }}>
                                                <div className="dashboard__container_img">
                                                    {(user?.teams && user?.teams.length > 0 && user?.teams[0]?.image && user?.teams[0]?.image !== "") ?
                                                        <img className="dashboard__container_img_logo" src={user?.teams[0]?.image} alt="" />
                                                        :
                                                        <img src={building} alt="" />
                                                    }
                                                </div>
                                                <div className="dashboard__container_body">
                                                    <div className="app__widget2_title">Équipe</div>
                                                    {(user?.teams && user?.teams.length > 0) &&
                                                        <div className="dashboard__team_name_container">
                                                            <div className="dashboard__team_name">{user?.teams[0]?.name}</div>
                                                            {/* Team Limitations */}
                                                            {user?.teams[0]?.plan?.limitations?.nb_capa_max &&
                                                                <>
                                                                    <div className="dashboard__team_name_limitations_spacer"></div>
                                                                    <div className="dashboard__team_name_limitations">{user?.teams[0]?.plan?.limitations?.nb_capa_max - capacityFullList.length < 1 ? "Obtenez un compte Premium pour continuer à créer des études capacitaires" : (user?.teams[0]?.plan?.limitations?.nb_capa_max - capacityFullList.length === 1 ? "1 étude restante" : ((user?.teams[0]?.plan?.limitations?.nb_capa_max - capacityFullList.length) + " études restantes"))}</div>
                                                                </>
                                                            }
                                                        </div>
                                                    }
                                                    {(user?.users && user.users.length > 0) &&
                                                        <div className="dashboard__team_preview_list">
                                                            {user.users.map((member, index) => {
                                                                return (
                                                                    <div key={"member_pic_" + index} className="dashboard__team_preview" style={{ left: (index * 15) + "px" }}>
                                                                        <img src={member.avatar} alt="" />
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="app__section_body_col2_row2 app__widget">
                                                {user?.users &&
                                                    <>
                                                        <div className="app__widget2_title">Membres de l'équipe</div>
                                                        <div className="dashboard__team_member_list">
                                                            {user.users.map((member, index) => {
                                                                return (
                                                                    <div key={"member_line_" + index} className="dashboard__team_member_container">
                                                                        {member?._id === user?.result?._id ?
                                                                            <>
                                                                                <div className="dashboard__team_member_img dashboard__team_member_col0"><img src={user?.result?.avatar} alt="" /></div>
                                                                                <div className="dashboard__team_member_text dashboard__team_member_col1">{user?.result?.firstName + " " + user?.result?.lastName}</div>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <div className="dashboard__team_member_img dashboard__team_member_col0"><img src={member.avatar} alt="" /></div>
                                                                                <div className="dashboard__team_member_text dashboard__team_member_col1">{member.firstName + " " + member.lastName}</div>
                                                                            </>
                                                                        }
                                                                        {window.innerWidth > 550 &&
                                                                            <>
                                                                                <div className="dashboard__team_member_col2">{member.email}</div>
                                                                            </>
                                                                        }
                                                                        {capacityFullList.length === 1 && capacityFullList[0] === "fetching" ?
                                                                            <div className="dashboard__team_member_col3"></div>
                                                                            :
                                                                            <>
                                                                                {capacityFullList.filter(study => study.creationUserId === member._id).length === 0 ?
                                                                                    <div className="dashboard__team_member_col3">Aucune étude</div>
                                                                                    :
                                                                                    <div className="dashboard__team_member_col3">{capacityFullList.filter(study => study.creationUserId === member._id).length} études</div>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </>
                                                }
                                                {window.innerWidth > 550 &&
                                                    <>
                                                        <div className="app__sectiondata_widget_spacer_30"></div>
                                                        <div className="app__widget2_title">Statistiques de l'équipe</div>
                                                        <div className="dashboard__team_stats_container">
                                                            {capacityFullList.length === 1 && capacityFullList[0] === "fetching" ?
                                                                <div className="app__sectiondata_loading_container_box" style={{ flex: "0.7" }}>
                                                                    <div className="app__sectiondata_loading"></div>
                                                                </div>
                                                                :
                                                                <div className="dashboard__team_stats_data_container">
                                                                    {/* <div className="dashboard__team_stats_data_subcontainer"> */}
                                                                    <div className="dashboard__value_container">
                                                                        <div className="dashboard__value_text">{user?.users ? user?.users.length : "0"}</div>
                                                                        <div className="dashboard__value_unit">membres</div>
                                                                    </div>
                                                                    <div className="dashboard__value_container">
                                                                        <div className="dashboard__value_text">{capacityFullList.length}</div>
                                                                        <div className="dashboard__value_unit">études<br />capacitaires</div>
                                                                    </div>
                                                                    {/* </div> */}
                                                                    {/* <div className="dashboard__value_container">
                                                                        <div className="dashboard__value_text">{helpers.get_pretty_num(Math.round(capacityFullList.map(study => study?.simplified?.land_area || 0).reduce((prev, next) => prev + next)))}</div>
                                                                        <div className="dashboard__value_unit">m² étudiés</div>
                                                                    </div> */}
                                                                    <div className="dashboard__value_container">
                                                                        {capacityFullList.length > 0 ?
                                                                            <div className="dashboard__value_text">{helpers.get_pretty_num(Math.round(capacityFullList.map(study => study?.simplified?.buildable_area || 0).reduce((prev, next) => prev + next)))}</div>
                                                                            :
                                                                            <div className="dashboard__value_text">0</div>
                                                                        }
                                                                        <div className="dashboard__value_unit">m² constructibles</div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className="dashboard__team_stats_map_container">
                                                                <MiniMap capacityFullList={capacityFullList} />
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {window.innerWidth > 550 ?
                                        <div id="dashboard_last_studies" className="app__section_body_col3 app__widget">
                                            {(!user?.teams || user?.teams.length <= 0) &&
                                                <div className="app__section_hide">
                                                </div>
                                            }
                                            <div className="app__widget2_title">Dernières études capacitaires</div>
                                            <div className="dashboard__study_list_container">
                                                <div className="dashboard__study_list">
                                                    {capacityFullList.length === 1 && capacityFullList[0] === "fetching" ?
                                                        <div className="app__sectiondata_loading_container_box">
                                                            <div className="app__sectiondata_loading"></div>
                                                        </div>
                                                        :
                                                        <>
                                                            {capacityFullList.length === 0 ?
                                                                <div className="dashboard__study_empty">
                                                                    <div className="app__sectiondata_loading_text" style={{ maxWidth: "270px" }}>
                                                                        <span style={{ fontSize: "20px" }}>👍</span><br></br>Commencez dès maintenant en créant votre première étude capacitaire
                                                                    </div>
                                                                    <div className={`combi__launch_button ${isCreatingNewCapa ? "combi__launch_button_loading" : ""}`} onClick={() => { createNewCapa() }}>{isCreatingNewCapa ? "Création ..." : "Nouvelle étude capacitaire"}</div>
                                                                </div>
                                                                :
                                                                <>
                                                                    {/* {capacityFullList.slice(0, 6).map((capaData, index) => { */}
                                                                    {capacityFullList.map((capaData, index) => {
                                                                        if (index === 0) { nbCapaTop = 0 }
                                                                        if (nbCapaTop < 6 && !(capaData?.groups && capaData.groups.length === 1 && (capaData.groups[0].includes("batch_") || capaData.groups[0].includes("variant_")))) {
                                                                            nbCapaTop++;
                                                                            return (
                                                                                <div key={"mini_capa" + index} className={`dashboard__study_container ${capaData?.isModel === true ? "app__card_top_container_model" : ""}`} onClick={() => { openCapa(capaData._id) }}>
                                                                                    <div className="dashboard__study_land_container">
                                                                                        {(capaData?.simplified?.poly?.bounds_groups && capaData?.simplified?.poly?.bounds_groups.length) > 0 ?
                                                                                            <svg width="800" height="800" viewBox="-20 -20 840 840" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                <polygon points={helpers.get_svgCoords_from_boundsGroupsList(capaData?.simplified?.poly?.bounds_groups, capaData?.simplified?.poly?.bbox).join(" ")} fillRule="evenodd" fill="#FFFFFF" fillOpacity="0.1" stroke="white" strokeWidth="8" />
                                                                                                {capaData?.simplified?.poly?.bounds_groups.map((item, index) => {
                                                                                                    return (
                                                                                                        <circle key={"circle_" + index} cx={helpers.get_svgCoords_from_localCoords([item.start_coord_local], capaData?.simplified?.poly?.bbox)[0][0]} cy={helpers.get_svgCoords_from_localCoords([item.start_coord_local], capaData?.simplified?.poly?.bbox)[0][1]} r="14" fill="white" />
                                                                                                    )
                                                                                                })}
                                                                                            </svg>
                                                                                            :
                                                                                            <img src={logo_card} alt="" />
                                                                                        }
                                                                                    </div>
                                                                                    <div className="dashboard__study_info_container">
                                                                                        <div className="dashboard__study_info_title">{capaData.title}</div>
                                                                                        {/* <div className="dashboard__study_info_description">Description de la nouvelle étude</div> */}
                                                                                        <div className="app__card_bottom_tags">
                                                                                            {capaData?.isModel === true &&
                                                                                                <span>Modèle PLU</span>
                                                                                            }
                                                                                            {capaData?.simplified?.city &&
                                                                                                <span>{capaData?.simplified.city}</span>
                                                                                            }
                                                                                            {(capaData?.isModel === false && capaData?.simplified?.zones && capaData?.simplified?.zones !== "") &&
                                                                                                <span>{capaData?.simplified?.zones}</span>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })}
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                    {/* <div className="dashboard__study_container">
                                                    <div className="dashboard__study_land_container"></div>
                                                    <div className="dashboard__study_info_container">
                                                        <div className="dashboard__study_info_title">Nouvelle étude capacitaire</div>
                                                        <div className="dashboard__study_info_description">Description de la nouvelle étude</div>
                                                    </div>
                                                </div>
                                                <div className="dashboard__study_container"></div>
                                                <div className="dashboard__study_container"></div>
                                                <div className="dashboard__study_container"></div>
                                                <div className="dashboard__study_container"></div> */}
                                                </div>
                                                {capacityFullList.length > 0 &&
                                                    <div className="dashboard__study_new_container">
                                                        <div className={`dashboard__study_new_btn ${isCreatingNewCapa ? "dashboard__study_new_btn_loading" : ""}`} onClick={() => { createNewCapa() }}>
                                                            {isCreatingNewCapa ? "Création ..." :
                                                                <>
                                                                    <span style={{ fontSize: '24px' }}>+</span>⠀Nouvelle étude
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className="app__sectiondata_widget_spacer_1"></div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='section_1' className="dashboard__sectiondata_container">
                        <div className="dashboard__sectiondata_title_container" style={{ marginBottom: "0px" }}>
                            <h3 id="dashboard_title_1">{layout[1]['title_long']}</h3>
                            <div className="dashboard__sectiondata_title_bar"></div>
                        </div>
                        <div className="dashboard__sectiondata_body_container">
                            {capacityFullList.length === 1 && capacityFullList[0] === "fetching" ?
                                <div id="card_container" className="dashboard__sectiondata_loading_container">
                                    <div className="app__sectiondata_loading"></div>
                                    <div className="app__sectiondata_loading_text">Nous récupérons vos études et celles de votre équipe</div>
                                </div>
                                :
                                <>
                                    <div className="app__section_filter_container">
                                        {(!user?.teams || user?.teams.length <= 0) &&
                                            <div className="app__section_hide"></div>
                                        }
                                        <Filter capacityFullList={capacityFullList} setCapacityFilteredList={setCapacityFilteredList} capacitySearch={capacitySearch} setCapacitySearch={setCapacitySearch} user={user} />
                                    </div>
                                    {/* <motion.div layout id="card_container" className={isLeft ? 'app__section_card_container_left' : 'app__section_card_container_space'}> */}
                                    <div id="card_container" className={isLeft ? 'app__section_card_container_left' : 'app__section_card_container_space'} style={{ columnGap: gridGap + "px" }}>
                                        {(!user?.teams || user?.teams.length <= 0) ?
                                            <div className="app__section_hide">
                                                <div className="app__sectiondata_loading_text" style={{ width: "70%" }}>
                                                    Vous devez être Premium pour utiliser toutes les fonctionnalités de Proplab.
                                                </div>
                                                <div className="app__section_hide_buttons">
                                                    <div className="combi__launch_button" onClick={() => { prepareEmail() }}>Passer Premium</div>
                                                    <div className="combi__launch_button_white" onClick={() => { prepareEmail() }}>Essayer gratuitement</div>
                                                </div>
                                            </div>
                                            :
                                            <NewCapa user={user} capacityFullList={capacityFullList} setCapacityFullList={setCapacityFullList} setCapacityFilteredList={setCapacityFilteredList} setToasterMessage={setToasterMessage} />
                                        }
                                        {/* <AnimatePresence> */}
                                        {capacityFilteredList.map((item, index) => {
                                            if (capacityFilteredLimit === null || index < capacityFilteredLimit) {
                                                return (
                                                    <Card key={"main_capa" + index} capaData={item} user={user} capacityFullList={capacityFullList} setCapacityFullList={setCapacityFullList} setCapacityFilteredList={setCapacityFilteredList} />
                                                )
                                            }
                                        })}
                                        {/* </AnimatePresence> */}
                                    </div>
                                    {capacityFullList.length > capacityFilteredLimit &&
                                        <div className="app__context_housing_detail_button_container" onClick={() => { switchCapacityFilteredLimit() }} style={{ marginTop: "6px" }}>
                                            {capacityFilteredLimit === null &&
                                                <div className="app__context_housing_detail_button_up"><img src={ico_arrow} alt="arrow_up" /></div>
                                            }
                                            <div className="app__context_housing_detail_button">{capacityFilteredLimit === null ? "Afficher moins d'études capacitaires" : "Afficher toutes les études capacitaires"}</div>
                                            {capacityFilteredLimit !== null &&
                                                <div className="app__context_housing_detail_button_down"><img src={ico_arrow} alt="arrow_up" /></div>
                                            }
                                        </div>
                                    }
                                    {/* </motion.div> */}
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="app__section_footer_mobile"></div>
            </div >
        );
    }
};

export default Dashboard;